export default {
  state: {
    selectedCoupon: [],
  },
  mutations: {
    SET_SelectedCoupons(state, val) {
      state.selectedCoupon = val
    },
  },
  getters: {
    getSelectedCoupons: state => state.selectedCoupon,
  },
}
